import Image from "next/image";

export const PRODUCT_CONTRACT_MANAGEMENT_INFORMATION = {
  title: "Launch & Customize Your NFT Smart Contracts Instantly",
  highlight: "NFT Smart Contracts",
  description:
    "Mintology’s API‑first platform lets you create shared or fully branded smart contracts in minutes. Configure royalties, supply caps, and more – then focus on your vision while we handle the blockchain.",
  image: "/images/products/contract-hero-image.webp",
  imageInfo: "Hero image for Mintology Contract Management page",
  bgImage: false,
  buttonText: "Launch a Contract Now!",
};

export const PRODUCT_CONTRACT_MANAGEMENT_BRAND_ENGAGEMENT = {
  title: "Conquer Smart‑Contract Complexity with Mintology",
  highlight: "Smart‑Contract Complexity",
  titleHeight: 60,
  revenue_streams: [
    {
      image: "/images/products/code-block-coloured-image.webp",
      title: "Zero‑Code Contract Deployment",
      description:
        "Create gasless ERC‑721 contracts via API or dashboard, no smart‑contract coding needed.​",
    },
    {
      image: "/images/products/contract-image.webp",
      title: "Total Contract Customization",
      description:
        "Set royalties, mint limits, and access rules on the fly. Tailor every parameter to your project’s needs.",
    },
    {
      image: "/images/products/shared-contract-image.webp",
      title: "Shared vs. Dedicated Flexibility",
      description:
        "Go live fast with shared contracts, or claim full control and branding with dedicated deployments.",
    },
  ],
};

export const PRODUCT_CONTRACT_MANAGEMENT_KEY_FEATURES = {
  title: "Power‑Up Your NFT Strategy with Mintology’s Core Features",
  highlight: "Power‑Up Your NFT Strategy",
  features: [
    {
      attribute: "Revolutionary",
      title: "Gasless Minting",
      description:
        "Mint NFTs with zero gas fees, perfect for high‑volume drops.",
    },
    {
      attribute: "Customizable",
      title: "Configurable Royalties",
      description:
        "Ensure creators earn on every resale by setting royalty rates directly in your contract.",
    },
    {
      attribute: "Intuitive",
      title: "Easy Deployment",
      description:
        "Configure and launch NFT contracts in minutes with our dashboard and APIs.",
    },
    {
      attribute: "Modular",
      title: "Live Metadata Updates",
      description:
        "Refresh NFT traits, images, and utilities post‑mint. No redeploys, no downtime.",
    },
    {
      attribute: "Real-time",
      title: "Actionable Analytics",
      description:
        "Monitor contract performance, mint stats, and user behavior in real time via dashboard or API.",
    },
    {
      attribute: "Adaptable",
      title: "Seamless Wallet Support",
      description:
        "Integrate custodial or non‑custodial wallet flows to streamline user onboarding and transactions.",
    },
  ],
};

export const PRODUCT_CONTRACT_MANAGEMENT_INTEGRATION = {
  title: "Embed Smart Contracts into Your Existing Apps",
  highlight: "Embed",
  description:
    "Plug Mintology’s APIs into your CMS, CRM, or custom backend. From contract creation and metadata management to analytics, control every facet of your NFT lifecycle with simple HTTP calls.",
};

export const PRODUCT_CONTRACT_MANAGEMENT_WHY_USE = {
  title: "Why Smart Contracts Matter for your business?",
  highlight: "Smart Contracts Matter",
  description:
    "Smart contracts are the backbone of trustless digital commerce. Here’s why they’re non‑negotiable.",
  use_cases: [
    {
      image: (
        <Image
          src="/images/products/automate-image.png"
          alt="Products placeholdero image"
          height={100}
          width={300}
          className=" object-contain hidden md:flex"
        />
      ),
      title: "Automate & Secure",
      description:
        "Predefine every action (minting, claiming, royalties) so code enforces your rules, not manual processes.",
    },
    {
      image: (
        <Image
          src="/images/products/immutable-trust-image.png"
          alt="Products placeholdero image"
          height={100}
          width={250}
          className=" object-contain hidden md:flex"
        />
      ),
      title: "Immutable Trust",
      description:
        "Once live, contracts can’t be tampered with, giving users confidence and reducing dispute risk.",
    },
    {
      image: (
        <Image
          src="/images/products/transparent-audits-image.png"
          alt="Products placeholdero image"
          height={100}
          width={280}
          className=" object-contain hidden md:flex"
        />
      ),
      title: "Transparent Audits",
      description:
        "Every transaction is recorded on‑chain, delivering a clear, verifiable trail for compliance and reporting.",
    },
  ],
};

export const PRODUCT_CONTRACT_MANAGEMENT_CTA = {
  title: "Ready to Revamp your Strategy with Smart Contracts?",
  highlight: "Ready to Revamp",
  buttonText: "Launch a Contract Now!",
};
